"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const browser_logs_1 = require("@datadog/browser-logs");
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const utils_1 = require("./utils");
class DatadogLogger {
    constructor(clientToken, service, site = 'datadoghq.eu', env = 'dev', version = '1.0.0', errorsToRedact = [], 
    // optional param to extend or rewrite datadog logger init configs
    datadogLogOptions) {
        const message = (name) => `${name} is not specified`;
        if (!clientToken) {
            throw Error(message('Client token'));
        }
        if (!service) {
            throw Error(message('Service name'));
        }
        this._canSendEvent = true;
        this.initDatadogLogs(clientToken, service, site, env, version, errorsToRedact, datadogLogOptions);
    }
    setUserData(userId, userEmail) {
        this._userEmail = (0, utils_1.redactEmailAddress)(userEmail);
        this._userId = userId;
    }
    unsetUserData() {
        this._userEmail = undefined;
        this._userId = undefined;
    }
    debug(message, messageContext, customProperties = []) {
        this.emitLogMessage('debug', message, messageContext, customProperties);
    }
    info(message, messageContext, customProperties = []) {
        this.emitLogMessage('info', message, messageContext, customProperties);
    }
    warn(message, messageContext, customProperties = []) {
        this.emitLogMessage('warn', message, messageContext, customProperties);
    }
    error(message, messageContext, customProperties = [], error = null) {
        this.emitLogMessage('error', message, messageContext, customProperties, error);
    }
    setHandlerType(value) {
        browser_logs_1.datadogLogs.logger.setHandler(value);
        this._canSendEvent = value !== browser_logs_1.HandlerType.silent;
    }
    getHandlerType() {
        return browser_logs_1.datadogLogs.logger.getHandler();
    }
    initDatadogLogs(clientToken, service, site, env, version, errorsToRedact, datadogLogOptions) {
        const initLogsConfiguration = {
            clientToken,
            site,
            service,
            env,
            version
        };
        browser_logs_1.datadogLogs.init({
            ...datadogLogOptions,
            ...initLogsConfiguration,
            beforeSend: (log) => {
                if (!Array.isArray(errorsToRedact)) {
                    return true;
                }
                if (!errorsToRedact.every((error) => typeof error === 'string')) {
                    return true;
                }
                if (errorsToRedact.find((error) => log === null || log === void 0 ? void 0 : log.message.includes(error))) {
                    return false;
                }
                return this._canSendEvent;
            }
        });
    }
    emitLogMessage(type, message, messageContext, customProperties = [], error = null) {
        if (!messageContext) {
            messageContext = {};
        }
        else if (!(0, utils_1.checkIfObject)(messageContext)) {
            messageContext = {
                message: messageContext
            };
        }
        // Clean the Body sent for failed HTTP calls
        // Could be sensitive data such as password when login fails.
        const cleanedContext = this.cleanMessageContext(messageContext, customProperties);
        cleanedContext['userId'] = this._userId;
        cleanedContext['email'] = this._userEmail;
        // @ts-ignore
        const errorContext = error || (cleanedContext === null || cleanedContext === void 0 ? void 0 : cleanedContext.error);
        if (errorContext) {
            browser_logs_1.datadogLogs.logger.error(message, cleanedContext, errorContext);
        }
        else {
            browser_logs_1.datadogLogs.logger[type](message, cleanedContext);
        }
    }
    cleanMessageContext(messageContext, customProperties) {
        var _a, _b, _c, _d, _e, _f;
        const clone = (0, lodash_clonedeep_1.default)(messageContext);
        if ((_b = (_a = clone === null || clone === void 0 ? void 0 : clone.error) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.data) {
            delete clone.error.config.data;
        }
        if ((_d = (_c = clone === null || clone === void 0 ? void 0 : clone.error) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.headers) {
            delete clone.error.config.headers.Authorization;
        }
        if ((_f = (_e = clone === null || clone === void 0 ? void 0 : clone.error) === null || _e === void 0 ? void 0 : _e.request) === null || _f === void 0 ? void 0 : _f.__sentry_xhr__) {
            delete clone.error.request.__sentry_xhr__;
        }
        return (0, utils_1.trimPropertiesFromObject)(clone, customProperties);
    }
}
exports.default = DatadogLogger;
//# sourceMappingURL=DatadogLogger.js.map